export default __webpack_public_path__ + "static/media/rusbath3.70c02ddf.jpeg";